import { useState } from 'react';

export const useCohortCharacteristicsTabularDataDialog = () => {
  const [displayDataDialog, setDisplayDataDialog] = useState<boolean>(false);

  const onShowDataDialog = () => {
    setDisplayDataDialog(true);
  };

  const onHideDataDialog = () => {
    setDisplayDataDialog(false);
  };

  return {
    displayDataDialog,
    onShowDataDialog,
    onHideDataDialog,
  };
};
